import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import AuthButton from 'app/pages/Auth/components/AuthButton';
import AuthError from 'app/pages/Auth/components/AuthError';
import AuthField from 'app/pages/Auth/components/AuthField';
import AuthHeading from 'app/pages/Auth/components/AuthHeading';
import AuthLink from 'app/pages/Auth/components/AuthLink';

import { submitLogin } from '../../../auth/store/loginSlice';

const schema = yup
  .object({
    username: yup
      .string()
      .email('You must provide valid email address')
      .required('Email is required'),
    password: yup
      .string()
      .min(8, 'Password must be at least 8 symbols long')
      .max(32, 'Password must be less than 32 symbols long')
      .required('Password is required'),
  })
  .required();

function LoginForm() {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });
  const { error, isLoading: loginInProgress } = useSelector(({ auth }) => auth.login);
  const onSubmit = (data) => dispatch(submitLogin(data));

  return (
    <>
      <AuthHeading title="Sign in to your account" />
      <form
        className="vtwo:flex vtwo:flex-col vtwo:gap-6"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="vtwo:flex vtwo:flex-col vtwo:gap-4">
          <AuthField
            label="Email"
            type="email"
            autoComplete="username"
            error={errors.username?.message}
            {...register('username')}
          />
          <AuthField
            label="Password"
            type="password"
            autoComplete="current-password"
            error={errors.password?.message}
            {...register('password')}
          />
        </div>

        {Boolean(error) && <AuthError message={error} />}

        <div className="vtwo:flex vtwo:flex-col vtwo:gap-4">
          <AuthButton type="submit" isLoading={loginInProgress}>
            Sign in
          </AuthButton>
          <AuthLink to="/forgot-password">I forgot my password</AuthLink>
        </div>
      </form>
    </>
  );
}

export default LoginForm;
